import { computed, observable, transaction, makeObservable } from "mobx"
import { RootStore } from "stores/root.store"
import { BaseStore } from "stores/base.store"
import { getAccountInstalledPackages, updateAccountPackage } from "../api/installed-packages.call"

export interface AccountInstalledPackage {
  accountId: string,
  platformId: string,
  createdAt: string,
  active: boolean,
}

export class AccountTrackingStore extends BaseStore {
  @observable
  private _accountInstalledPackages: AccountInstalledPackage[] = []
  @observable
  private _currentId: string

  @observable
  public isEmptyArr: boolean = false

  public isLoading: boolean = false

  constructor(rootStore: RootStore) {
    super(rootStore)
    makeObservable(this)
  }
  public async getData() {
    this.isEmptyArr = false

    if (this._currentId) {
      return this.getInstalledPackages(this._currentId)
    } else {
      return []
    }
  }

  public async getInstalledPackages(id: string) {
    this.resetFuncAfterSuccess()
    if (this._currentId !== id) {
      this._currentId = id
      this._accountInstalledPackages = []
    }
    this.isEmptyArr = false

    const accountInstalledPackages = await this.defaultFunction(
      getAccountInstalledPackages,
      id,
    )
    if (accountInstalledPackages) {
      transaction(() => {
        this.isLoading = false
        if (accountInstalledPackages?.length === 0) {
          this.isEmptyArr = true
        }
        this._accountInstalledPackages = accountInstalledPackages
      })
    }

    return accountInstalledPackages
  }

  public async updateInstalledPackage(accountId: string, platformId: string, active: boolean) {
    const updatedPackage = await this.defaultFunction(updateAccountPackage, accountId, platformId, active)
    this._accountInstalledPackages = this._accountInstalledPackages.map(pkg => {
      if (pkg.platformId === updatedPackage.platformId && pkg.accountId === updatedPackage.accountId) {
        return { ...pkg, ...updatedPackage }
      }

      return pkg
    })
  }

  @computed
  get accountInstalledPackages(): AccountInstalledPackage[] {
    return this._accountInstalledPackages
  }
}
